import { updateUser } from '@simplywallst/services';
import { withAuth } from '@utilities/queries';
import type { Payload } from '@simplywallst/services/lib/endpoints/updateUser';
import type { AxiosError } from 'axios';

export default async function mutationFn(payload: Payload) {
  try {
    const response = await withAuth(updateUser, payload);
    return response.data.data;
  } catch (unknownError) {
    const axiosError = unknownError as AxiosError;
    if (axiosError.isAxiosError && typeof axiosError.response !== 'undefined') {
      throw new Error(axiosError.response.data.errors[0].title);
    }
    throw unknownError;
  }
}
